<template>
    <div>
        <div class="modal-title-big">
            Пользователь
        </div>
        <div class="ap-modal-element profile-grid">
            <div>Имя:</div>
            <div>{{userName}}</div>
            <div>E-mail:</div>
            <div>{{userEmail}}</div>
            <div>Роль:</div>
            <div>{{userRole}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserInfo",
    computed: {
        userName() {
            const name = this.$store.state.profile.userName;
            if (name) {
                return name;
            } else {
                return 'Гость';
            }
        },
        userEmail() {
            const email = this.$store.state.profile.userEmail;
            if (email) {
                return email;
            } else {
                return 'N/a';
            }
        },
        userRole() {
            const role = this.$store.state.profile.userRole;
            if (role) {
                return this.rolesTranslations[role];
            } else {
                return 'N/a';
            }
        }
    },
    data() {
        return {
            rolesTranslations: {
                superadmin: 'Супер-Администратор',
                admin: 'Администратор'
            }
        }
    },
}
</script>

<style scoped>
    .profile-grid {
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 40px;
        grid-row-gap: 20px;
    }
</style>